import { VisibilityOption } from '@front-app/services/GroupsApi/GroupEvent';
import { GroupWithCommunity } from '@front-app/services/GroupsApi/GroupModel';
import {
	isAdminRole,
	isModeratorRole,
	isMemberRole,
	hasGroupAccess,
} from '@front-app/util/permission';
import { get, MaybeRef } from '@vueuse/shared';

/**
 * A utility function which aims to determine if the current user has access to
 * view a group's content or not, based on the current user and the group.
 */
export const isGroupContentVisible = (
	group: MaybeRef<GroupWithCommunity | undefined>,
	isCsr: MaybeRef<boolean>,
	isLoggedIn: MaybeRef<boolean>,
): boolean => {
	const groupVisibility = get(group)?.visibilitySettings.visibility;
	const role = get(group)?.role;
	switch (groupVisibility) {
	case undefined:
		return false;
	case VisibilityOption.PUBLIC:
		return true;
	case VisibilityOption.ALL_TIMEDRIGHT_USERS:
		return get(isLoggedIn);
	case VisibilityOption.USERS_WITH_ACCESS:
		if (!get(isLoggedIn)) {
			return false;
		}
		return hasGroupAccess(get(group), get(isCsr));
	case VisibilityOption.MEMBERS_ONLY:
		if (!get(isLoggedIn)) {
			return false;
		}
		return isAdminRole(role)
			|| isModeratorRole(role)
			|| isMemberRole(role);
	default:
		// eslint-disable-next-line
		const unwanted: never = groupVisibility;
		throw new Error(`Unable to satisfy component validation request for type: ${unwanted}`);
	}
};
